import React from 'react'
import { withTranslation } from 'react-i18next'
import { PageHeading, BoardMembersList } from '../components/Fragments'
import { sicentificBoard, walkOfFame, editorialBoard } from '../data/boards'

function Boards({ t }) {
  return (
    <>
      <PageHeading pageTitle='menu.boards' acronym='acronym' researchCenter='cavas_research_center' />

      <div className="uk-child-width-expand@s uk-text-center" data-uk-grid>
        <div>
          <div className="uk-card uk-card-default uk-card-body">
            <div>
              <h4>{t('pages.boards.sicentific_board')}</h4>
              <ul className="uk-list uk-list-large uk-list-divider">
                {<BoardMembersList list={sicentificBoard} />}
              </ul>
            </div>
          </div>
        </div>

        <div>
          <div className="uk-card uk-card-default uk-card-body">
            <div>
              <h4>{t('pages.boards.walk_of_fame')}</h4>
              <ul className="uk-list uk-list-large uk-list-divider">
                {<BoardMembersList list={walkOfFame} />}
              </ul>
            </div>
          </div>
        </div>
        
        <div>
          <div className="uk-card uk-card-default uk-card-body">
            <div>
              <h4>{t('pages.boards.editorial_board')}</h4>
              <ul className="uk-list uk-list-large uk-list-divider">
                {<BoardMembersList list={editorialBoard} />}
              </ul>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default withTranslation()(Boards)